import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { useOBMutation } from './useOBMutation';
interface DeleteAppointmentProps {
  appointmentId: string | null;
  practiceId: string | null;
}

const useDeleteAppointment = ({
  appointmentId,
  practiceId,
}: DeleteAppointmentProps) => {
  const url = useApiUrl(
    OBRoutes.AppointmentDelete,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )
    ?.replace('##appointmentId', appointmentId ?? '')
    .replace('##practiceId', practiceId ?? '');

  return useOBMutation(url || '', {
    method: 'DELETE',
  });
};

export default useDeleteAppointment;
